<mat-dialog-content>
    <div class="flex-row flex-space-between p-20 bg-accent">
        <div>
            <mat-card-header>
                <mat-card-title>
                    My settings
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon class="accent-text">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="p-20">
        <a routerLink="/account-deletion" mat-stroked-button mat-dialog-close>Delete account</a>
        <p>Request permanent deletion of your account and associated personal data.</p>
    </div>
    <mat-tab-group color="accent">
        <mat-tab label="Settings">
            <div class="p-10">
                <div class="p-10">
                    <form [formGroup]="settingsForm">
                        <div class="rowThree">
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label>Username</mat-label>
                                <input formControlName="username" matInput>
                                @if (settingsForm.controls['username'].hasError('required')) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label>Email</mat-label>
                                <input formControlName="email" matInput type="email">
                                @if (settingsForm.controls['email'].hasError('required')) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                }
                                @if (settingsForm.controls['email'].hasError('email')) {
                                    <mat-error>
                                        A valid email is required
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label>Post code</mat-label>
                                <input formControlName="postcode" matInput>
                            </mat-form-field>
                        </div>
                        <div class="rowTwo">
                            <div class="flex-col">
                                <p>{{ community?.profile_picture_title_text ? community?.profile_picture_title_text : 'Profile picture' }}</p>
                                <div class="text-center">
                                    @if (!image && currentUser) {
                                        <div (click)="fileInput.click()"
                                             [appUserAvatar]="currentUser"
                                             aria-label="Update Profile Picture" class="initial"
                                             matTooltip="Update profile picture" role="button">
                                            <span>{{ currentUser?.username | slice: 0 : 1 | titlecase }}</span>
                                        </div>
                                    }
                                    @if (showCropper) {
                                        <div style="width: 250px;margin:auto">
                                            <image-cropper
                                                    (imageCropped)="imageCropped($event)"
                                                    [aspectRatio]="1"
                                                    [imageChangedEvent]="imageChangedEvent"
                                                    [maintainAspectRatio]="true"
                                                    [resizeToWidth]="250"
                                                    [roundCropper]="true"
                                                    format="png"
                                            ></image-cropper>
                                        </div>
                                    }
                                    @if (image) {
                                        <img (click)="fileInput.click()" [src]="image" alt=""
                                             aria-label="Update Profile Picture"
                                             class="pp" matTooltip="Update profile picture">
                                    }
                                    <input #fileInput (change)="onFileInput($event)" [multiple]="false"
                                           accept=".jpg, .jpeg, .png, .bmp, .svg, .webp" class="d-none" type="file"/>
                                </div>
                                @if (community?.profile_picture_help_text_rendered) {
                                    <div [innerHTML]="community?.profile_picture_help_text_rendered">
                                    </div>
                                }
                                @if (!community?.profile_picture_help_text_rendered) {
                                    <small>Click to update profile picture</small>
                                    <small>Max file size: {{ this.maxFileSize }}MB</small>
                                    <small>Minimum size: 100 x 100</small>
                                    <small>Allowed formats: JPG, JPEG, PNG, BMP, SVG, WEBP</small>
                                    <small>Please note your profile picture will be visible to other community
                                        members.</small>
                                }
                            </div>
                            <div class="flex-auto">
                                <mat-form-field appearance="outline" class="w-100 h-100 fullHeightChildren"
                                                color="accent">
                  <textarea #textarea
                            [placeholder]="community?.bio_placeholder_text? community?.bio_placeholder_text : 'Bio'"
                            formControlName="bio"
                            matInput maxlength="400"
                            name="message"
                            rows="1"></textarea>
                                </mat-form-field>
                            </div>
                            @if (!community?.disable_dark_mode) {
                                <div class="flex-auto">
                                    <span id="themeOptionsLabel" class="themeLabel">Choose Theme</span>
                                    <mat-radio-group aria-labelledby="themeOptionsLabel" formControlName="theme_mode">
                                        <mat-radio-button value="default" [disableRipple]="true">Inherit System Default
                                        </mat-radio-button>
                                        <mat-radio-button value="light" [disableRipple]="true">Light</mat-radio-button>
                                        <mat-radio-button value="dark" [disableRipple]="true">Dark</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            }
                        </div>
                    </form>
                </div>
                <div class="w-100 text-center my-10">
                    <button (click)="updateProfile()" [disabled]="this.settingsForm.invalid" color="accent"
                            mat-raised-button>
                        Submit
                    </button>
                </div>
            </div>

        </mat-tab>
        <mat-tab label="Password">
            <div class="p-10">
                <form [formGroup]="passwordForm" class="p-20">
                    <!--                <mat-form-field appearance="outline" class="w-100" color="primary">-->
                    <!--                    <mat-label>Current Password</mat-label>-->
                    <!--                    <input #oldPassword formControlName="oldPassword" matInput-->
                    <!--                           type="password">-->
                    <!--                    <mat-error (click)="oldPassword.focus()"-->
                    <!--                               *ngIf="passwordForm.controls['oldPassword'].hasError('required')">-->
                    <!--                        This field is required-->
                    <!--                    </mat-error>-->
                    <!--                </mat-form-field>-->
                    <div class="rowTwo">
                        <div>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <mat-label>New password</mat-label>
                                <input #password formControlName="password" matInput maxlength="32" minlength="8"
                                       required type="password">
                                @if (passwordForm.controls['password'].hasError('required')) {
                                    <mat-error (click)="password.focus()"
                                    >
                                        This field is required
                                    </mat-error>
                                }
                                @if (passwordForm.controls['password'].hasError('minlength')) {
                                    <mat-error (click)="password.focus()"
                                               [style.color]="community?.password_minimum_character_alert_colour_hex">
                                        Password must be at least 8 characters long
                                    </mat-error>
                                }
                                @if (passwordForm.controls['password'].hasError('maxlength')) {
                                    <mat-error (click)="password.focus()"
                                    >
                                        Password must be at less than 32 characters long
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <mat-label>Confirm password</mat-label>
                                <input #confirmPassword formControlName="confirmPassword"
                                       matInput required type="password">
                                @if (passwordForm.controls['confirmPassword'].hasError('required')) {
                                    <mat-error (click)="confirmPassword.focus()"
                                    >
                                        This field is required
                                    </mat-error>
                                }
                                @if (confirmPassword.value && password.value && password.value != confirmPassword.value) {
                                    <mat-hint (click)="confirmPassword.focus()"
                                              class="errorMsg">
                                        Fields must match
                                    </mat-hint>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </form>
                <div class="w-100 text-center my-10">
                    <button (click)="updatePassword()"
                            [disabled]="this.passwordForm.invalid || password.value != confirmPassword.value"
                            color="accent"
                            mat-raised-button>
                        Submit
                    </button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
